module.exports = __webpack_public_path__ + "img/5.9ff6b139.png";